// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] || chunkId) + "." + {"440":"3287f48f","453":"2804a5c8","581":"00dc9884","831":"8d204a73"}[chunkId] + ".chunk.js";
};